/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    IsoDayOfWeekType,
    IsoDayOfWeekTypeFromJSON,
    IsoDayOfWeekTypeFromJSONTyped,
    IsoDayOfWeekTypeToJSON,
    TimeOfDayRange,
    TimeOfDayRangeFromJSON,
    TimeOfDayRangeFromJSONTyped,
    TimeOfDayRangeToJSON,
} from './';

/**
 * 
 * @export
 * @interface CriteriaForBookingDateTimeOutput
 */
export interface CriteriaForBookingDateTimeOutput {
    /**
     * 
     * @type {Array<IsoDayOfWeekType>}
     * @memberof CriteriaForBookingDateTimeOutput
     */
    daysOfWeek?: Array<IsoDayOfWeekType> | null;
    /**
     * 
     * @type {boolean}
     * @memberof CriteriaForBookingDateTimeOutput
     */
    exclude?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof CriteriaForBookingDateTimeOutput
     */
    from?: Date;
    /**
     * 
     * @type {string}
     * @memberof CriteriaForBookingDateTimeOutput
     */
    ianaTimeZone?: string | null;
    /**
     * 
     * @type {Array<TimeOfDayRange>}
     * @memberof CriteriaForBookingDateTimeOutput
     */
    timesOfDay?: Array<TimeOfDayRange> | null;
    /**
     * 
     * @type {Date}
     * @memberof CriteriaForBookingDateTimeOutput
     */
    to?: Date | null;
}

export function CriteriaForBookingDateTimeOutputFromJSON(json: any): CriteriaForBookingDateTimeOutput {
    return CriteriaForBookingDateTimeOutputFromJSONTyped(json, false);
}

export function CriteriaForBookingDateTimeOutputFromJSONTyped(json: any, ignoreDiscriminator: boolean): CriteriaForBookingDateTimeOutput {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'daysOfWeek': !exists(json, 'daysOfWeek') ? undefined : (json['daysOfWeek'] === null ? null : (json['daysOfWeek'] as Array<any>).map(IsoDayOfWeekTypeFromJSON)),
        'exclude': !exists(json, 'exclude') ? undefined : json['exclude'],
        'from': !exists(json, 'from') ? undefined : (new Date(json['from'])),
        'ianaTimeZone': !exists(json, 'ianaTimeZone') ? undefined : json['ianaTimeZone'],
        'timesOfDay': !exists(json, 'timesOfDay') ? undefined : (json['timesOfDay'] === null ? null : (json['timesOfDay'] as Array<any>).map(TimeOfDayRangeFromJSON)),
        'to': !exists(json, 'to') ? undefined : (json['to'] === null ? null : new Date(json['to'])),
    };
}

export function CriteriaForBookingDateTimeOutputToJSON(value?: CriteriaForBookingDateTimeOutput | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'daysOfWeek': value.daysOfWeek === undefined ? undefined : (value.daysOfWeek === null ? null : (value.daysOfWeek as Array<any>).map(IsoDayOfWeekTypeToJSON)),
        'exclude': value.exclude,
        'from': value.from === undefined ? undefined : (value.from.toISOString()),
        'ianaTimeZone': value.ianaTimeZone,
        'timesOfDay': value.timesOfDay === undefined ? undefined : (value.timesOfDay === null ? null : (value.timesOfDay as Array<any>).map(TimeOfDayRangeToJSON)),
        'to': value.to === undefined ? undefined : (value.to === null ? null : value.to.toISOString()),
    };
}


